import { useParams } from "react-router-dom";
import Card from "../../components/Card/Card";
import http from "../../http-common";
import { toast } from "react-toastify";
import { useState } from "react";
import { useEffect } from "react";
import VacancyForm from "./VacancyForm";
import { Button, Tab, Tabs } from "carbon-components-react";
import InternshipFillingInstructions from "../../components/Miscellaneous/InternshipFillingInstructions";
import { ArrowLeft20 } from "@carbon/icons-react";
import { ArrowRight20 } from "@carbon/icons-react";
import InternshipTermsAndConditions from "../../components/Miscellaneous/InternshipTermsAndConditions";

const UpdateVacancyPage = () => {
  const params = useParams();
  const [uuid] = useState(params.uuid);
  const [vacancy, setVacancy] = useState({});
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const getVacancy = async () => {
      try {
        const result = await http.get(`/internships/vacancies/${uuid}`);
        setVacancy(result.data);
      } catch (error) {
        toast.error(error.response?.data.message);
      }
    };

    getVacancy();
  }, [uuid]);

  const nextTab = () => {
    setActiveTab((prev) => prev + 1);
  };
  const previousTab = () => {
    setActiveTab((prev) => prev - 1);
  };

  return (
    <Card title="Vaga de Estágio">
      <Tabs
        scrollIntoView={false}
        selected={activeTab}
        type={"container"}
        onSelectionChange={(e) => setActiveTab(e)}
      >
        <Tab href="#" id="tab-0" label="Termos e Condições">
          <InternshipTermsAndConditions />
          <div className="tab-navigation">
            <p></p>
            <Button kind="ghost" size="sm" onClick={nextTab}>
              Próximo <ArrowRight20 />
            </Button>
          </div>
        </Tab>
        <Tab href="#" id="tab-1" label="Vaga">
          <VacancyForm operation="UPDATE" vacancy={vacancy} />
          <div className="tab-navigation">
            <Button kind="ghost" size="sm" onClick={previousTab}>
              <ArrowLeft20 /> Anterior
            </Button>
          </div>
        </Tab>
      </Tabs>
    </Card>
  );
};
export default UpdateVacancyPage;
